/* eslint-disable no-throw-literal */
import { Dispatch } from "redux";
import api, { APIResponse, errorHandler } from "../../config/api";

export interface LoginDataType {
  employeeId: string;
  password: string;
}

export interface RolePermissionType {
  id?: number;
  pageKey: string;
  pageName: string;
   pageTitle?: string | null;
  pageUrl?: string | null;
  add?: boolean;
  view?: boolean;
  edit?: boolean;
  delete?: boolean;
}
export interface RoleMaster {
  id?: number;
  roleName: string;
  status: string;
}

export interface Role {
  id: number;
  name: string;
  permissions?: RolePermissionType[];
}
export interface RolePermissionPayload {
  roleId: number;
  permissions: Array<{
    pageTitle: string;
    pageUrl: string;
    add: number;
    view: number;
    edit: number;
    delete: number;
  }>;
}
export interface MenuItemTypes {
  key: string;
  label: string;
  isTitle?: boolean;        
  Icon?: any;
  url?: string;
  badge?: {                
    variant: string;
    text: string;
  };
  parentKey?: string;       
  target?: string;         
  children?: MenuItemTypes[];
}
export interface AuthUserType {
  employeeId: string;
  token?: string;
  password?: string;
  status?: string;
  name: string;
  mobileNumber: string;
  emailId: string;
  role: string;
  designation?: string;
  expireAt?: number;
  rolePermissions?: RolePermissionType[];
  photoUrl: string;
}

export enum AuthUserActionList {
  LOGIN_USER = "LOGIN_USER",
  LOGOUT_USER = "LOGOUT_USER",
  SIGNUP_USER = "SIGNUP_USER",
}

export interface SignupAction {
  type: AuthUserActionList.SIGNUP_USER;
  data: AuthUserType;
}

export interface LoginAction {
  type: AuthUserActionList.LOGIN_USER;
  data: AuthUserType;
}

export interface LogoutAction {
  type: AuthUserActionList.LOGOUT_USER;
  data: null;
}

export type AuthUserActions = SignupAction | LoginAction | LogoutAction;

export const signupUser = (data: AuthUserType) => {
  // api call
};

export const loginUser = (data: LoginDataType) => {
  return async (dispatch: Dispatch) => {
    return api
      .post<APIResponse<AuthUserType>>("/employee/login/", data)
     .then((response) => {
        if (response.status === 200 && response.data.data) {
          const authData = response.data.data;
          if (authData.token) {
            localStorage.setItem("token", authData.token);
            localStorage.setItem("authUser", JSON.stringify(authData));
          }
          
          dispatch<LoginAction>({
            type: AuthUserActionList.LOGIN_USER,
            data: authData,
          });
          return Promise.resolve(
            response.data.message
              ? response.data.message
              : "Successfully logged in",
          );
        } else {
          throw { response };
        }
      })
      .catch((error) => {
        return Promise.reject(errorHandler(error, "Unable to login"));
      });
  };
};

export const logoutUser = () => {
  return (dispatch: Dispatch) => {
     localStorage.removeItem("token");
    localStorage.removeItem("authUser");
    localStorage.removeItem("persist:root"); 
    sessionStorage.clear();
    dispatch<LogoutAction>({
      type: AuthUserActionList.LOGOUT_USER,
      data: null,
    });
  };
};
